import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFnEnergyCostCard from "ApiLayer/Reports/Baseline/queryCurrentAnnualEnergyCostCard";

export const useCurrentAnnualEnergyCostCard = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["currentAnnualEnergyCostCard", filtersetUid],
        queryFn: async () =>
            queryFnEnergyCostCard(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
    });
};
